import React, { useEffect, useRef, useState } from "react";

// Repère « deep link » venu d'une notification : fait défiler jusqu'à l'élément puis le fait
// pulser une fois (halo émeraude .yalola-attn-pulse) — même signal sur PC et sur téléphone.
export const AttnPulse = ({ active = false, delay = 450, className = "", testId, children }) => {
  const ref = useRef(null);
  const [pulse, setPulse] = useState(false);
  const done = useRef(false);
  useEffect(() => {
    if (!active || done.current) return undefined;
    const tm = setTimeout(() => {
      done.current = true;
      ref.current?.scrollIntoView?.({ behavior: "smooth", block: "center" });
      setPulse(true);
      setTimeout(() => setPulse(false), 2200);
    }, delay);
    return () => clearTimeout(tm);
  }, [active, delay]);
  return <div ref={ref} className={`${className} ${pulse ? "yalola-attn-pulse" : ""}`.trim()} data-testid={testId} data-pulse={pulse ? "1" : undefined}>{children}</div>;
};

export default AttnPulse;
